import React from 'react';
import { 
  RocketLaunchIcon, 
  ExclamationTriangleIcon, 
  WrenchScrewdriverIcon, 
  LightBulbIcon 
} from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import StageCards from '../../../components/playbooks/StageCards';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import { getPlaybookById } from '../../../data/playbookTaxonomy';

// Stage icons mapping
const stageIcons = {
  'stage-1': <ExclamationTriangleIcon className="h-6 w-6" />,
  'stage-2': <WrenchScrewdriverIcon className="h-6 w-6" />,
  'stage-3': <LightBulbIcon className="h-6 w-6" />
};

export default function HowToExecute() {
  // Get stage sections from the taxonomy
  const playbook = getPlaybookById('we-fucked-up');
  const stageSections = playbook?.sections.filter(section => section.id.startsWith('stage-')) || [];

  return (
    <div className="space-y-8">
      <PlaybookSection
        title="How To Execute"
        icon={<RocketLaunchIcon className="h-7 w-7 text-primary-light" />}
        heading="Follow these stages to navigate through the aftermath"
      >
        <div className="prose prose-invert max-w-none">
          <p className="text-gray-300">
            This playbook breaks down the process of handling a f*ck up into three clear stages. Each stage builds upon the previous one, helping you move from crisis management to long-term improvement. Click into each tile to find a concise distillation of 25+ years experience that helps guide you through each stage.
          </p>
        </div>

        <StageCards 
          stages={stageSections}
          icons={stageIcons}
          playbookId="we-fucked-up"
          introText="Our step-by-step guide through each stage of handling a mistake. Select a stage to dive deeper into the process."
        />

      </PlaybookSection>
    </div>
  );
} 